import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/hooks/useAppSelector";

interface RequireCompanySetupProps {
  children: React.ReactNode;
}

export function RequireCompanySetup({ children }: RequireCompanySetupProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, companySetupComplete } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { state: { from: location.pathname } });
      return;
    }
    
    if (!companySetupComplete) {
      navigate("/company-setup");
      return;
    }
  }, [navigate, isAuthenticated, companySetupComplete, location.pathname]);

  return <>{children}</>;
}